import * as React from "react";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router";
import { Action, Dispatch } from "redux";
import { createClientPmCampaignActionCreator } from "../action/client_pm_campaign";
import ClientPmCampaignComponent from "../component/client/campaign/client_pm_campaign";
import {
  IClientPmCampaignDispatcher,
  createClientPmCampaignDispatcher,
} from "../dispatcher/client_pm_campaign";
import { GetCustomersByPmCampaignPageRequest } from "../request/customer_request";
import { AppState } from "../store/app_state";
import { ClientPmCampaignState } from "../store/client_pm_campaign_store";

interface IProps extends RouteComponentProps<{}> {
  state: ClientPmCampaignState;
  dispatcher: IClientPmCampaignDispatcher;
}

interface IState {
  isInit: boolean;
}

// 開発・STG環境には本番で固定表示するエキスパートが存在しないため、
// 本番と同じ枚数になるようダミーユーザーを並べて固定表示する。
// 本番のみ指定されたエキスパートを表示する。
const DEV_DUMMY_CUSTOMER_ID = "I6xc7Rg717Q8AxpSwmDbIpuynyr2";

const fixedCustomerIDs = (forProd: string[]): string[] => {
  if (process.env.REACT_APP_LIBERA_ENV === "prod") {
    return forProd;
  }
  return forProd.map(() => DEV_DUMMY_CUSTOMER_ID);
};

export class ClientPmCampaignContainer extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      isInit: true,
    };
  }

  public componentDidMount() {
    const req: GetCustomersByPmCampaignPageRequest =
      new GetCustomersByPmCampaignPageRequest();

    // プロジェクトマネージャー
    req.pmCustomerIDs = fixedCustomerIDs([
      "8o5KnSQPysSRlaJPm2NMfDGsgnn2", // 安井 歩
      "1njgSyZTkya2IyLo59WIMH8ogQD2", // 一階武史
      "5xwqnm1jMtduDb2byG5FrmRkiPm1", // 平家 和憲
      "yWYXmr0B2rN5LHIT6KiRAQREnUB2", // 藁谷直優
      "nWmEyLhphPcoaYnZ4ttx8GUQthh2", // 大平 和史
    ]);

    // ① toB型のPM
    req.toBPmCustomerIDs = fixedCustomerIDs([
      "27jAvXnCizbmAx1EGQq8CrprxIy1", // 岩渕史武
      "MKqAYC7vfhg7O78AqhmbIscPCVE3", // 泉 純一郎
    ]);

    // ① toC型のPM
    req.toCPmCustomerIDs = fixedCustomerIDs([
      "aKQARluy08SVwZnljSne5UbIwZw2", // 宮島 弘行
      "yNNdQyCu85dwNKVb6t75Kte0jyV2", // 緑川 貴裕
    ]);

    // ② 新規事業タイプのPM
    req.bizdevPmCustomerIDs = fixedCustomerIDs([
      "5juAsJ3rzKZEVTveK6fYEYMHdJM2", // 飯田直規
      "n03a4xQRdUSlIYvi575XfdRFzuo1", // 今井 義人
    ]);

    // ② グロースハックタイプのPM
    req.growthPmCustomerIDs = fixedCustomerIDs([
      "Dg9vKe4fp3h13t2RoR1uU2hYrk62", // 岩本佑太
      "VxQWvvcz19ZLXTUaCEAItDGmt583", // 甲斐 淳仁
    ]);

    // ③ PMM
    req.pmmCustomerIDs = fixedCustomerIDs([
      "P3bwAxvX5BR27VU3Dh8oCfgWH5q2", // 佐々木敏明
      "V1adYj1UvufD87AarkAKFm203vL2", // 渡邉 和貴
    ]);

    // ③ PO（プロダクトオーナー）
    req.poCustomerIDs = fixedCustomerIDs([
      "FZBmB2Xpuqaq0BRHqBeTX5RGcVs1", // 北川 淳一郎
      "sM1TEMLPd4YWpu5youLuiCbYIK62", // Charles Du
    ]);

    this.props.dispatcher.getCustomers(req);
  }

  public componentDidUpdate(prevProps: IProps, prevState: IState) {
    // init処理の終了
    const isInitFinished: boolean =
      this.state.isInit &&
      !this.props.state.isLoading &&
      prevProps.state.isLoading;
    if (isInitFinished) {
      return this.setState({ isInit: false });
    }
  }

  public render(): JSX.Element {
    const { state } = this.props;
    const {
      pmCustomers,
      toBPmCustomers,
      toCPmCustomers,
      bizdevPmCustomers,
      growthPmCustomers,
      pmmCustomers,
      poCustomers,
      jobCareersWithCustomerID,
      clientBookmarks,
      isLoading,
    } = state;

    return (
      <ClientPmCampaignComponent
        isLoading={isLoading}
        pmCustomers={pmCustomers}
        toBPmCustomers={toBPmCustomers}
        toCPmCustomers={toCPmCustomers}
        bizdevPmCustomers={bizdevPmCustomers}
        growthPmCustomers={growthPmCustomers}
        pmmCustomers={pmmCustomers}
        poCustomers={poCustomers}
        clientBookmarks={clientBookmarks}
        jobCareersWithCustomerID={jobCareersWithCustomerID}
      />
    );
  }
}

const mapStateToProps = (state: AppState) => {
  return {
    state: state.clientPmCampaignReducer,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
  return {
    dispatcher: createClientPmCampaignDispatcher(
      dispatch,
      createClientPmCampaignActionCreator()
    ),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClientPmCampaignContainer);



// WEBPACK FOOTER //
// ./src/presentation/container/client_pm_campaign_container.tsx